import { differenceInCalendarDays, format, parseISO } from 'date-fns';

export const TODAY = new Date(2026, 9, 6);

export function baht(amount: number): string {
  return `฿${Math.round(amount).toLocaleString('en-US')}`;
}

export function formatDate(iso: string, pattern = 'EEE d MMM'): string {
  return format(parseISO(iso), pattern);
}

export function daysUntil(iso: string): number {
  return differenceInCalendarDays(parseISO(iso), TODAY);
}

export function formatTime(iso: string): string {
  return format(parseISO(iso), 'HH:mm');
}

export function bookingFee(amount: number): number {
  return Math.max(150, Math.round(amount * 0.06));
}
